package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.Availability
import com.evoapps.evoshift.domain.repository.AvailabilityRepository

class GetRosterAvailabilityUseCase(
    private val availabilityRepository: AvailabilityRepository
) {
    suspend operator fun invoke(rosterId: String): Result<List<Availability>> {
        return availabilityRepository.getAvailabilityForRoster(rosterId)
    }
}
